import moment from 'moment-timezone';

export function dateDiffNow(strTime) {
  const now = moment().tz('Asia/Seoul');
  const target = moment(strTime).tz('Asia/Seoul');
  return Math.abs(now.diff(target));
}
